import React from "react";
import { IoIosTrash, IoIosWallet, IoIosAttach } from "react-icons/io";
import { FiEdit2 } from "react-icons/fi";
import { FormatDate, FormatNumber } from "../../helpers";

export default function TransactionCard(props) {
  const { data, isFocused } = props;
  const isIncome = data.amount >= 0;
  const tags = data.tags || [];

  const edit = (e) => {
    if (e) e.stopPropagation();
    localStorage.setItem("cashflow", JSON.stringify(data));
    props.history.push("/transaction/edit/" + data.id);
  };

  const remove = (e) => {
    e.stopPropagation();
    if (props.onDelete) props.onDelete(data);
  };

  const searchByTag = (e, t) => {
    e.stopPropagation();
    localStorage.setItem("tag", JSON.stringify(t));
    props.history.push("/transaction-search");
  };

  return (
    <article
      id={`trx-card-${data.id}`}
      className={`trx-card trx-card--${isIncome ? "in" : "out"} ${
        isFocused ? "trx-card--focused" : ""
      }`}
      onClick={edit}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && edit()}
    >
      <span className="trx-card__rail" aria-hidden />
      <div className="trx-card__body">
        <div className="trx-card__row trx-card__row--primary">
          <div className="trx-card__desc">
            {data.attachmentUrl && (
              <span className="trx-card__attach" title="Ada lampiran">
                <IoIosAttach />
              </span>
            )}
            {data.description || (isIncome ? "Pemasukan" : "Pengeluaran")}
          </div>
          <div className="trx-card__amount">
            {isIncome ? "+" : "−"}Rp{" "}
            {FormatNumber(Math.abs(Math.round(data.amount)))}
          </div>
        </div>
        <div className="trx-card__row trx-card__row--meta">
          <div className="trx-card__metainfo">
            <span className="trx-card__date">{FormatDate(data.date)}</span>
            <span className="trx-card__sep" aria-hidden>
              ·
            </span>
            <span className="trx-card__wallet">
              <IoIosWallet /> {data.wallet && data.wallet.name}
            </span>
            {tags.length > 0 && (
              <span className="trx-card__tags">
                {tags.map((t, i) => (
                  <button
                    key={i}
                    type="button"
                    className="trx-tag trx-tag--mini"
                    onClick={(e) => searchByTag(e, t)}
                  >
                    {t.tag}
                  </button>
                ))}
              </span>
            )}
          </div>
          <div className="trx-card__actions">
            <button
              type="button"
              className="trx-card__action"
              title="Edit"
              aria-label="Edit"
              onClick={edit}
            >
              <FiEdit2 />
            </button>
            <button
              type="button"
              className="trx-card__action trx-card__action--danger"
              title="Hapus"
              aria-label="Hapus"
              onClick={remove}
            >
              <IoIosTrash />
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}
